// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"241":"d66d0e16","289":"95293076","806":"8e7699dc"}[chunkId] + ".chunk.css";
};